import React from "react";
import Breadcrumb from "../../Component/Breadcrumb";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useAuth } from "../../Store/AuthContext";
import ContactFormEnquery from "../../Component/ContactCMPT/ContactFormEnquery";
import GoogleMapSection from "../../Component/GoogleMapSection";

export default function Contact() {
  const { webSetting, Pagemetatags } = useAuth();
  return (
    <>
      <Helmet>
        <title>{Pagemetatags.contacttitle}</title>
        <meta name="description" content={Pagemetatags.contactdescription} />
        <meta name="keywords" content={Pagemetatags.contactkeyword} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <Breadcrumb pagename="Contact" mainpage="" />

      <section className="contact-section-3 fix section-padding">
        <div className="container">
          <div className="contact-info-wrapper">
            <div className="section-title text-center">
              <h2>Contact Us</h2>
              <p className="mt-3 text-center">
                Schedule a tour today and explore our fully furnished homes.
                Experience stylish, move-in-ready spaces designed for <br />{" "}
                comfort, convenience, and modern living. Let us help you find
                your perfect fit.
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-7 col-md-12 mt-5">
              <div className="contact-wrapper-10">
                <div className="section-title text-center mb-0">
                  <h2 className="wow fadeInUp aboutSectiontitle">
                    {/* <i className="fa fa-angle-double-left" aria-hidden="true"></i>{" "} */}
                    Keep In Touch{" "}
                    {/* <i className="fa fa-angle-double-right" aria-hidden="true"></i> */}
                  </h2>
                </div>

                <ContactFormEnquery />
              </div>
            </div>
            <div className="col-lg-5 col-md-12 mt-5">
              <div className="contacksidebox">
                <div className="contact-info-box">
                  <div className="icon">
                    <i className="fa-solid fa-location-dot"></i>
                  </div>
                  <div className="content">
                    <h3>Location</h3>
                    <p className="text-start mb-2">
                      <b>Pune Office : </b> {webSetting?.address || ""}
                    </p>
                    <p className="text-start">
                      <b>Gwalior Office : </b> {webSetting?.address2 || ""}
                    </p>
                  </div>
                </div>

                <div className="contact-info-box">
                  <div className="icon">
                    <i className="fa-solid fa-phone-xmark"></i>
                  </div>
                  <div className="content">
                    <h3>Phone</h3>
                    <p>
                      <Link to={`tel:+91${webSetting?.number || ""}`}>
                        +91 {webSetting?.number || ""}
                      </Link>
                      <span className="me-2 ms-2">|</span>
                      <Link to={`tel:+91${webSetting?.number || ""}`}>
                        +91 {webSetting?.number2 || ""}
                      </Link>
                    </p>
                    <p className=""> </p>
                  </div>
                </div>

                <div className="contact-info-box">
                  <div className="icon">
                    <i className="fa-solid fa-envelopes"></i>
                  </div>
                  <div className="content">
                    <h3>Email</h3>
                    <p className="">
                      {" "}
                      <Link to={`mailto:${webSetting?.email || ""}`}>
                        {webSetting?.email || ""}
                      </Link>
                      <span className="me-2 ms-2">|</span>
                      <Link to={`mailto:${webSetting?.email2 || ""}`}>
                        {webSetting?.email2 || ""}
                      </Link>
                    </p>
                    <p className=""></p>
                  </div>
                </div>
                <div className="contact-info-box">
                  <div className="icon">
                    <i className="fab fa-whatsapp"></i>
                  </div>
                  <div className="content">
                    <h3>Whatsapp</h3>
                    <p className="">
                      {" "}
                      <Link
                        target="_blank"
                        to={`https://wa.me/+91${
                          webSetting?.whatsaap || ""
                        }?text=Hi, I would like to speak to a Bhadorva Infra`}
                        className="me-2"
                      >
                        +91 {webSetting?.whatsaap || ""}
                      </Link>
                    </p>
                    <p className=""></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <GoogleMapSection />
    </>
  );
}
